import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "./components/AppShell.js";
import { ApprovalsPage } from "./pages/ApprovalsPage.js";
import { ChatPage } from "./pages/ChatPage.js";
import { HotelDetailPage } from "./pages/HotelDetailPage.js";
import { HotelsPage } from "./pages/HotelsPage.js";
import { NewResearchJobPage } from "./pages/NewResearchJobPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";
import { ResearchJobDetailPage } from "./pages/ResearchJobDetailPage.js";
import { ResearchJobsPage } from "./pages/ResearchJobsPage.js";
import { SettingsPage } from "./pages/SettingsPage.js";

function LegacyLeadRedirect() {
  const { hotelId } = useParams();
  return <Navigate to={`/hotels/${hotelId ?? ""}`} replace />;
}

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Navigate to="/research-jobs" replace />} />
        <Route
          path="research-jobs"
          element={<ResearchJobsPage />}
          handle={{ title: "Research Jobs" }}
        />
        <Route
          path="research-jobs/new"
          element={<NewResearchJobPage />}
          handle={{ title: "Neuer Research Job" }}
        />
        <Route
          path="research-jobs/:jobId"
          element={<ResearchJobDetailPage />}
          handle={{ title: "Research Job" }}
        />
        <Route
          path="hotels"
          element={<HotelsPage />}
          handle={{ title: "Pipeline" }}
        />
        <Route
          path="hotels/:hotelId"
          element={<HotelDetailPage />}
          handle={{ title: "Lead Detail" }}
        />
        <Route path="pipeline" element={<Navigate to="/hotels" replace />} />
        <Route path="leads/:hotelId" element={<LegacyLeadRedirect />} />
        <Route
          path="approvals"
          element={<ApprovalsPage />}
          handle={{ title: "Approvals" }}
        />
        <Route
          path="chat"
          element={<ChatPage />}
          handle={{ title: "Chat" }}
        />
        <Route
          path="chat/:conversationId"
          element={<ChatPage />}
          handle={{ title: "Chat" }}
        />
        <Route
          path="settings"
          element={<SettingsPage />}
          handle={{ title: "Settings" }}
        />
        <Route
          path="*"
          element={<NotFoundPage />}
          handle={{ title: "Nicht gefunden" }}
        />
      </Route>
    </Routes>
  );
}
